import React from 'react';
import { useTranslation } from 'react-i18next';
import './Contact.css';

function Contact() {
  const { t } = useTranslation();

  return (
    <div className="contact-page">
      <div className="contact-header">
        <div className="container">
          <h1>{t('contact.title')}</h1>
          <p>{t('contact.subtitle')}</p>
        </div>
      </div>

      <div className="contact-content">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <h2>{t('contact.getInTouch')}</h2>
              <p>{t('contact.description')}</p>

              <div className="contact-methods">
                <div className="contact-method">
                  <div className="method-icon">📧</div>
                  <div className="method-details">
                    <h3>{t('contact.email')}</h3>
                    <a href="mailto:alhamdulillah399@gmail.com">alhamdulillah399@gmail.com</a>
                  </div>
                </div>

                <div className="contact-method">
                  <div className="method-icon">💬</div>
                  <div className="method-details">
                    <h3>{t('contact.support')}</h3>
                    <p>{t('contact.supportDesc')}</p>
                  </div>
                </div>

                <div className="contact-method">
                  <div className="method-icon">🕐</div>
                  <div className="method-details">
                    <h3>{t('contact.responseTime')}</h3>
                    <p>{t('contact.responseTimeDesc')}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="contact-form-section">
              <h2>{t('contact.sendMessage')}</h2>
              <form className="contact-form">
                <div className="form-group">
                  <label htmlFor="name">{t('contact.form.name')}</label>
                  <input type="text" id="name" name="name" required />
                </div>

                <div className="form-group">
                  <label htmlFor="email">{t('contact.form.email')}</label>
                  <input type="email" id="email" name="email" required />
                </div>

                <div className="form-group">
                  <label htmlFor="subject">{t('contact.form.subject')}</label>
                  <input type="text" id="subject" name="subject" required />
                </div>

                <div className="form-group">
                  <label htmlFor="message">{t('contact.form.message')}</label>
                  <textarea id="message" name="message" rows="6" required></textarea>
                </div>

                <button type="submit" className="submit-btn">
                  {t('contact.form.send')}
                </button>
              </form>

              <p className="form-note">{t('contact.directEmail')}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
